import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { getClientPageData } from '../../common/dom';
import App from './DayCancellationPage.vue';
import '@rei/cedar/dist/cdr-reset.css';
import '@rei/cedar/dist/cdr-fonts.css';
import '@rei/cedar/dist/style/cdr-container.css';
import '@rei/cedar/dist/style/cdr-text.css';
import '@rei/cedar/dist/style/cdr-button.css';
import '@rei/cedar/dist/style/cdr-link.css';
import '@rei/cedar/dist/style/cdr-input.css';
import '@rei/cedar/dist/style/cdr-checkbox.css';
import '@rei/cedar/dist/style/cdr-select.css';
import '@rei/cedar/dist/style/cdr-toast.css';
import '@rei/cedar/dist/style/cdr-skeleton.css';
import '@rei/cedar/dist/style/cdr-skeleton-bone.css';
import '@rei/cedar/dist/style/cdr-icon.css';
import '@rei/cedar/dist/style/cdr-banner.css';
import '@rei/cedar/dist/style/cdr-form-group.css';
import '@rei/cedar/dist/style/cdr-list.css';

const { pageData } = getClientPageData();

const app = createApp(App, pageData);
const pinia = createPinia();

app.use(pinia);

app.mount('#app');
